import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=19721982&scoped=true&"
import script from "./operate.vue?vue&type=script&lang=js&"
export * from "./operate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19721982",
  null
  
)

export default component.exports